import { qportalApi } from './qportal-api';
export const adminHoursApi = {
    list: (status, expectedActorId, signal) => qportalApi.get('timeSheet/AdminHours', { params: { status, expectedActorId }, signal }),
    inProgress: (expectedActorId, signal) => qportalApi.get('timeSheet/AdminInProgress', { params: { expectedActorId }, signal }),
    detail: (timeSheetIds, expectedActorId, signal) => qportalApi.post('timeSheet/AdminHoursDetail', { timeSheetIds, expectedActorId }, { signal })
};
